/* eslint-disable consistent-return */
import { DuoGrid, Form, LineSpacer } from './styles';
import React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { FrameData } from '../../components/FrameData';
import { AutoRow } from 'components/AutoRow';
import Input from 'components/AutoRow/components/Input';
import { Button } from 'components/AutoRow/components/Button';
import { FaSearch } from 'react-icons/fa';
import { useIframeContext } from 'contexts/IframeContext';
import { makeHandleSubmit } from 'helpers/makeHandleSubmit';
import { EmptyData } from 'components/EmptyData';
import { FaRegCompass } from 'react-icons/fa6';
import { MdMyLocation } from 'react-icons/md';

const IframeBusca = ({ history }: RouteComponentProps) => {
  const {
    dadosConsultaAreaColeta,
    handleBuscarAreaColeta,
    setDadosConsultaAreaColeta,
    erroConsultaAreaColeta,
  } = useIframeContext();

  const { loading, enderecoBuscado, loading_buscar_com_localizacao } = dadosConsultaAreaColeta;

  const handleSearch = async (usarPosicaoAtual?: boolean) => {
    if (enderecoBuscado.startsWith('teste-rafa')) {
      const [, path] = enderecoBuscado.split('teste-rafa');
      return history.push(path.trim());
    }

    const success = await handleBuscarAreaColeta(usarPosicaoAtual);

    if (success) history.push('/coleta');
  };

  return (
    <FrameData centerContent={false}>
      <Form id="form-busca" target="_self" onSubmit={makeHandleSubmit(() => handleSearch())}>
        <AutoRow>
          <DuoGrid>
            <Input
              value={enderecoBuscado}
              name="endereco"
              label="Endereço"
              placeholder="Digite seu endereço com o número"
              type="text"
              handleFunction={(e) =>
                setDadosConsultaAreaColeta((prevState) => ({ ...prevState, enderecoBuscado: e.target.value }))
              }
            />

            <Button type="submit" loading={loading}>
              Buscar
              <FaSearch />
            </Button>
          </DuoGrid>
        </AutoRow>

        <div style={{ width: '100%', display: 'flex', gap: '8px', alignItems: 'center' }}>
          <div style={{ flex: 1, height: '1px', background: '#eae7e7' }}></div>
          <p style={{ color: '#a8a8a8' }}>ou</p>
          <div style={{ flex: 1, height: '1px', background: '#eae7e7' }}></div>
        </div>

        <div style={{ width: '100%', maxWidth: '400px', margin: '0 auto' }}>
          <Button type="button" loading={loading_buscar_com_localizacao} onClick={() => handleSearch(true)}>
            <MdMyLocation />
            Usar minha localização
          </Button>
        </div>

        {!!erroConsultaAreaColeta && (
          <>
            <LineSpacer />
            <EmptyData redColor noPadding icon={() => <FaRegCompass />}>
              <b>{erroConsultaAreaColeta}</b>
            </EmptyData>
          </>
        )}
      </Form>
    </FrameData>
  );
};

export default IframeBusca;
